import { Divider, Grid, useMediaQuery, useTheme } from '@mui/material';
import { Box } from '@mui/system';
import React from 'react';
import genericPage from '../../assets/images/genericPage.png';
import { StyledDescription } from '../../components/StyledDescription';
import { StyledTitle } from '../../components/StyledTitle';
import { useLoaderContext } from '../../contexts/LoaderContext';
import { _ } from '../../shared/utils';

export const SendReminderSuccessPage: React.FC = () => {

    const theme = useTheme();
    const matches = useMediaQuery(theme.breakpoints.up(970));
    const setLoader = useLoaderContext();

    React.useEffect(() => {
        setLoader(false);
        //_.redirectWithDelay();
    }, []);

    return (
        <Grid height="100%" container>
            {matches && (
                <Grid sm={5} sx={{ backgroundColor: '#fff', display: 'flex', alignItems: 'center', justifyContent: 'center' }} item>
                    <img src={genericPage} width="450" alt='genericPage' />
                </Grid>
            )}
            <Grid
                sm={matches ? 7 : 12}
                sx={{ background: "#f2f2f2" }}
                item
            >
                <Box
                    display="flex"
                    justifyContent="center"
                    flexDirection="column"
                    gap={2}
                    overflow="auto"
                    height="100%"
                >
                    <StyledTitle>
                        Comunicazione promozione esclusiva!
                    </StyledTitle>
                    <Divider orientation="horizontal" />
                    <StyledDescription>
                        Abbiamo inviato la promozione pensata per te via e-mail all&#8217;indirizzo indicato.
                        <br />
                        <br />
                        Grazie
                    </StyledDescription>
                </Box>
            </Grid>
        </Grid>
    );
};
